import { LoadingSpinner } from '@/features/help/components/LoadingSpinner';
import { useFormSubmission } from '../../hooks/use-form-submission.hook';

interface FormNavigationProps {
  activePage: number;
  totalPages: number;
  theme: {
    background: string;
    accent: string;
    primary: string;
  };
  onNext: () => void;
  onBack: () => void;
  mappingId: string | undefined;
}

// Purpose: Handles form navigation and submission processs
export const FormNavigation = ({
  activePage,
  totalPages,
  theme: _theme,
  onNext,
  onBack,
  mappingId,
}: FormNavigationProps) => {
  const { handleSubmit, isSubmitting } = useFormSubmission({ mappingShortId: mappingId });

  const isFirstPage = activePage === 0;
  const isLastPage = activePage === totalPages - 1;

  return (
    <>
      <div className="!flex !flex-row items-center justify-between w-full px-2">
        {/* Back Button */}
        <button
          onClick={onBack}
          disabled={isFirstPage}
          className={`flex items-center justify-center text-sm w-[120px] md:w-[140px] px-6 py-2.5 rounded-full transition-all duration-200 font-medium ${
            isFirstPage
              ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:shadow-md border border-gray-300'
          }`}
        >
          <span>Back</span>
        </button>

        {/* Next/Submit Button */}
        {isLastPage ? (
          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            className={`flex items-center justify-center text-sm w-[120px] md:w-[140px] px-6 py-2.5 rounded-full transition-all duration-200 font-medium bg-blue-600 text-white hover:shadow-lg ${
              isSubmitting ? 'opacity-70 cursor-not-allowed' : 'hover:bg-blue-700'
            }`}
          >
            {isSubmitting ? (
              <div className="!flex !flex-row items-center gap-2">
                <LoadingSpinner className="h-5 w-5" />
                <span>Submitting...</span>
              </div>
            ) : (
              <span>Submit</span>
            )}
          </button>
        ) : (
          <button
            onClick={onNext}
            className="flex items-center justify-center text-sm w-[120px] md:w-[140px] px-6 py-2.5 rounded-full transition-all duration-200 font-medium bg-blue-600 text-white hover:bg-blue-700 hover:shadow-lg"
          >
            <span>Next</span>
          </button>
        )}
      </div>
    </>
  );
};
